// extracted by mini-css-extract-plugin
export var quantityInput = "_f6-0";